import meta from './meta.json'
import profile from './profile.json'
import settings from './settings.json'
import questions from './questions.json'
import general from './general.json'

export default {
  meta,
  profile,
  settings,
  questions,
  general
}
